<template>
    <div class="home">
        <span class="navContent">
        <b-icon
            id="previousMonth"
            v-on:click="previousMonth"
            icon="triangle-fill"
            title="Mois précédent"
          />
        <h1 class="title-page">Rapport sur le mois de {{this.months[this.currentMonth-1]}} {{this.currentYear}}</h1>
        <b-icon
            id="nextMonth"
            v-on:click="nextMonth"
            icon="triangle-fill"
            title="Mois suivant"
          />
        </span>

        <div>
            <p class="currentDate">date du jour : {{this.today[0]}} / {{this.today[1]}} / {{this.today[2]}}</p>
            <select
                id="userSelect"
                name="userSelect"
                @change="onChangeUser()"
                v-model="userId"
                title="Saisies pour l'utilisateur"
                v-show="$store.getters.isManager"
            >
                <option
                v-for="user in allUsers"
                v-bind:key="user.id"
                v-bind:value="user.id"
                >
                {{ user.login }}
                </option>
            </select>
        </div>

        <div class="stat-on-month">

            <div class="repport-hours_project">
                <p class="title-stat">Temps rapporté sur le mois :</p>
                <b-icon class="load-icon" icon="gear-fill" animation="spin" font-scale="7" v-if="loading"></b-icon>
                <HoursOnMonthChart ref="chart" v-else/>
            </div>
        
            <div class="aside">
                <div class="stat-aside">
                    <p class="title-stat">Heures rapportées sur le mois :</p>
                    
                    <p class="nb-stat-big">
                        <b-icon class="load-icon" icon="gear-fill" animation="spin" font-scale="1" v-if="loading"></b-icon>
                        <span class="alert-hours" v-else-if="+(Math.round(this.nb_hours_report_curMonth + 'e+2')  + 'e-2') < (this.nbDayInCurMonth - this.nb_week_end_days - this.numberHolidayInCurMonth) * 7">{{+(Math.round(this.nb_hours_report_curMonth + "e+2")  + "e-2")}}</span> 
                        <span class="plus-hours" v-else-if="+(Math.round(this.nb_hours_report_curMonth + 'e+2')  + 'e-2') > (this.nbDayInCurMonth - this.nb_week_end_days - this.numberHolidayInCurMonth) * 7">{{+(Math.round(this.nb_hours_report_curMonth + "e+2")  + "e-2")}}</span> 
                        <span class="actual-good-hours" v-else-if="currentYear == actualYear && currentMonth == actualMonth">{{+(Math.round(this.nb_hours_report_curMonth + 'e+2')  + 'e-2')}}</span>
                        <span class="good-hours" v-else>{{+(Math.round(this.nb_hours_report_curMonth + 'e+2')  + 'e-2')}}</span>
                        / {{(this.nbDayInCurMonth - this.nb_week_end_days - this.numberHolidayInCurMonth) * 7}}
                    
                        <span v-if="currentYear < actualYear || (currentYear == actualYear && currentMonth < actualMonth)">
                            <b-iconstack font-scale="0.7" class="time-icon warning-icon" v-if="+(Math.round(this.nb_hours_report_curMonth + 'e+2')  + 'e-2') < (this.nbDayInCurMonth - this.nb_week_end_days - this.numberHolidayInCurMonth) * 7">
                                <b-icon stacked icon="square"></b-icon>
                                <b-icon stacked icon="exclamation"></b-icon>
                            </b-iconstack>
                            <b-iconstack font-scale="0.7" class="time-icon valid-icon" v-else>
                                <b-icon stacked icon="square"></b-icon>
                                <b-icon stacked icon="check"></b-icon>
                            </b-iconstack>
                        </span>
                    
                    </p>
                    <div class="btn btn-success"><router-link class="dashboardLink" to="/dashboard">Saisir mes heures</router-link></div>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
    
    import HoursOnMonthChart from "./HoursOnMonthChart.vue"
    const axios = require('axios');

    export default {
        name: "Home",
        components: {
            HoursOnMonthChart,
        },
        created: function() {  

            //Recuperation des info utilisateur
            this.userId = Number(localStorage.id);
            this.role = localStorage.role;

            //Recuperation de la liste des utilisateurs pour le selecteur :
            //réservé aux rôles privilégiés (Admin/Responsable/Coresponsable).
            //Un simple utilisateur n'a pas accès aux données des autres
            //-> on n'appelle pas cet endpoint (qui renverrait 403) et le
            //sélecteur n'est pas affiché.
            if (this.$store.getters.isManager) {
                axios.get(this.$store.state.apiUrl + "user/users")
                    .then(response => this.allUsers = response.data)
                    .catch(e => { this.printError(e); });
            }

            //Recuperation des information de date
            var tmpDate = new Date();
            this.currentYear = tmpDate.getFullYear();
            this.actualYear = tmpDate.getFullYear();
            this.currentMonth = tmpDate.getMonth() + 1;
            this.actualMonth = tmpDate.getMonth() + 1;
            this.today = [("0" + tmpDate.getDate()).slice(-2), ("0" + this.currentMonth).slice(-2), this.currentYear];
        

            this.getData();
        },
        async mounted() {

            this.getCountResponsable();

            this.loading = false;
        },
        data() {
            return {
                currentMonth: 0,
                currentYear: 0,
                actualMonth: 0,
                actualYear: 0,
                today: [],
                userId: 0,
                role: "",
                logsForMonth: [],
                numberHolidayInCurMonth: 0,
                months: [
                    "Janvier",
                    "Février",
                    "Mars",
                    "Avril",
                    "Mai",
                    "Juin",
                    "Juillet",
                    "Août",
                    "Septembre",
                    "Octobre",
                    "Novembre",
                    "Décembre"
                ],
                days: ["L","M","M","J","V","S","D"],
                nbDayInCurMonth: 0,
                nb_week_end_days: 0,
                nb_hours_report_curMonth: 0,
                estimate_hours_for_project: [],
                loadingEstimate: true,
                loading: true,
                noProject: false,
                allUsers: [],
                maxToPrint: 22,
                repportProjects : [],
                showLivr : this.$store.getters.isManager ? 1 : 0,
                countReferentProject : 0,
                holidaysGantt: [],
            }
        },
        methods: {
            getData: function(){ /** Récupération des données du mois courrant */
                this.loading = true;

                //Initialisation du nombre de jours dans le mois 
                if([1,3,5,7,8,10,12].includes(this.currentMonth)) this.nbDayInCurMonth = 31;
                else if([4,6,9,11].includes(this.currentMonth)) this.nbDayInCurMonth = 30;
                else if(this.currentMonth == 2 && (this.currentYear % 4 == 0 && this.currentYear % 100 != 0 || this.currentYear % 400 == 0)) this.nbDayInCurMonth = 29;
                else this.nbDayInCurMonth = 28;

                if(this.currentYear == this.actualYear && this.currentMonth == this.actualMonth){
                    this.nbDayInCurMonth = new Date().getDate();
                }

                // Réccupération des jours fériés du mois courrant
                axios.get(this.$store.state.apiUrl + "holidays/monthly/" + this.currentMonth + "/" + this.currentYear, {
                    params: {
                    login: localStorage.login,
                    password: localStorage.pass
                    }
                })
                .then(response => {
                    var holidays_register = Object.values(response.data);

                    //Comptage des jours fériés autre que week-end
                    for(var i = 0 ; i < holidays_register.length; i++){
                        var date_holyday = holidays_register[i].date.split("/");

                        var day_holiday = new Date(this.currentYear,this.currentMonth - 1, parseInt(date_holyday[0])).getDay();
                        if( day_holiday != 0 && day_holiday != 6){
                            this.numberHolidayInCurMonth ++;

                            //Décomptage sur mois actuel si après date actuel
                            if(this.currentYear == this.actualYear && this.currentMonth == this.actualMonth && parseInt(date_holyday[0]) > this.nbDayInCurMonth)
                                this.numberHolidayInCurMonth --;
                        }
                    }
                })
                .catch(e => {
                    this.printError(e);
                });

                //Comptage du nombre de jours de week-end
                var day = new Date(this.currentYear, this.currentMonth-1,1).getUTCDay();
                for(var i = 0; i < this.nbDayInCurMonth; i++){
                    if(this.days[(day + i) % 7] == "S" || this.days[(day + i) % 7] == "D") this.nb_week_end_days++;
                }

                this.getLogs();
            },
            nextMonth: function(){ //Click Event right arrow
                this.currentMonth ++;
                if(this.currentMonth == 13){
                    this.currentMonth = 1;
                    this.currentYear++;
                }
                this.resetData();
                this.getData();
                this.$refs.chart.nextMonth();
                this.loading = false;
            },
            previousMonth: function(){ //Click Event left arrow
                this.currentMonth --;
                if(this.currentMonth == 0){
                    this.currentMonth = 12;
                    this.currentYear--;
                }
                this.resetData();
                this.getData();
                this.$refs.chart.previousMonth();
                this.loading = false;
            },
            onChangeUser: function(){ //Change Event users selector
                this.resetData();
                this.getCountResponsable();
                this.getData();
                this.loading = false;
                this.$refs.chart.changeUserId(this.userId);

            },
            resetData: function(){
                this.nb_week_end_days = 0;
                this.numberHolidayInCurMonth = 0;
                this.nb_hours_report_curMonth = 0;
                this.nbDayInCurMonth = 0;
            },
            getCountResponsable: function(){
                axios.get(this.$store.state.apiUrl + "project/responsable/" + this.userId, {
                    params: {
                    login: localStorage.login,
                    password: localStorage.pass
                    }
                })
                .then(response => {
                    this.countResponsable = response;
                });
            },
            getLogs: function(){

                // Récupération des temps saisis sur le mois courrant pour l'utilisateur connecté
                axios.get(this.$store.state.apiUrl + "time/monthly/" + this.userId + "/" + this.currentYear + "/" + this.currentMonth, {
                    params: {
                    login: localStorage.login,
                    password: localStorage.pass
                    }
                })
                .then(response => {
                    var allLogsInCurMonth = Object.values(response.data);
                    
                    // Comptage du nombre d'heures saisi dans le mois courrant pour l'utilisateur connecté
                    for(var i = 0 ; i < allLogsInCurMonth.length; i++){        
                        var log = allLogsInCurMonth[i];
                        if( parseInt(log.date.split("-")[2]) <= this.nbDayInCurMonth){
                            var duration = log.duration.split(':');
                            this.nb_hours_report_curMonth += parseInt(duration[0]) + (parseInt(duration[1]) / 60);
                        }
                    }
                })
                .catch(e => {
                    this.printError(e);
                });

            },
            printError: function(e) {
                console.log(e);
                this.$toasted.show("Erreur de connexion, veuillez essayer ultérieurement", {
                    position: "bottom-center",
                    theme: "outline"
                })
                .goAway(2000);
            },
            addDays :function(date,days){
                //Fonction d'ajout d'un nombre de jours à une date

                date = new Date(date);
                date.setDate(date.getDate() + days);
                return date;
            },
            getJourOuvre : function(start,end){
                //Fonction de calcul du nombre de jours ouvrés entre deux date (sans décompter les jours fériés)

                if(start.getMonth()+1 == this.actualMonth && start.getFullYear() == this.actualYear){
                    start = new Date(this.actualYear, this.actualMonth-1, new Date().getDate());
                }
                
                var days = 0;
                var loop = new Date(start);

                while(loop.getMonth() == end.getMonth()){
                    if(loop.getDay() != 0 && loop.getDay() != 6) days ++;
                    loop = new Date(loop.setDate(loop.getDate() + 1));
                }

                return days;
            },
            getNbDays: function(start, end){
                var days = 0;
                var loop = start;
                while(loop < end){
                    if(loop.getDay() != 0 && loop.getDay() != 6){
                        days ++;
                    }
                    loop = new Date(loop.setDate(loop.getDate() + 1));
                }
                return days + 1;
            }

        }
    }
</script>

<style scoped>

    .aside{
        width: 32%;
        margin: 5%;
        display: inline-table;
        vertical-align: text-top;
    }

    .repport-hours_project, .stat-aside{
        border: solid #bbb 1px;
        border-radius: 6px;
        box-shadow: 2px 2px 3px #ccc;
    }

    .stat-aside{
        margin-bottom: 10%;
        padding-top: 10px;
    }

    .nb-stat-big{
        font-size: 5em;
        font-weight: bold;
    }

    .alert-hours, .warning-icon{
        color: #f44;
    }

    .repport-hours_project{
        width: 40%;
        height: 100px;
        display: inline-table;
        padding-top: 10px;
        margin-right: 5%;
    }

    .plus-hours, .last-day-left{
        color: #f84;
    }

    .good-hours , .valid-icon{
        color: #8d8;
    }

    .actual-good-hours, .livraison-icon{
        color: #58f;
    }

    .title-stat{
        font-weight: bold;
        text-decoration: underline;
    }

    #nextMonth:hover,
    #previousMonth:hover{
        cursor: pointer;
    }

    #previousMonth,
    #nextMonth {
        font-size: 22px;
        margin-bottom: 7px;
    }

    #previousMonth {
        transform: rotate(-90deg);
        margin-right: 2%;
    }

    #nextMonth {
        transform: rotate(90deg);
        margin-left: 2%;
    }

    .title-page, #previousMonth, #nextMonth{
        display: inline-table;
    }
    
    .btn{
        margin-bottom: 3%;
    }

    .dashboardLink{
        color: whitesmoke;
        font-size: 1.3em;
        text-decoration: none;
    }

    .stat-on-month{
        margin-bottom: 5%;
    }

    .home{
        margin-bottom: 5%;
    }

    .title-page{
        width: 45%;
    }

    .time-icon{
        margin: 0;
    }

    .project-report-title{
        margin-bottom: 2%;
    }

    .time-icon{
        vertical-align: middle;
        margin-bottom: 2%;
    }

    .load-icon{
        margin-top: 5%;
        color: #fec053;
    }

    .currentDate{
        display: inline-block;
        margin-right: 1%;
    }

    .header-line{
        background-color: #fec053;
        font-weight: bold;
    }

    .repport-header{
        border-top: solid #e5a610 1px;
        border-bottom: solid #e5a610 1px;
    }

    .end-week-header, .end{
        border-right: solid #e5a610 1px;
    }

    .project-name-hearder{
        border: solid #e5a610 1px;
        padding-left: 0.5% !important;
        text-align: left;
    }

    .today-header{
        background-color: #e5a610 !important;
    }

    .repport-line{
        border-top: solid #bbb 1px;
    }

    .repport-table{
        overflow: scroll;
    }

    .data-table{
        border: solid #bbb 1px ;
        margin: auto;
        margin-bottom: 2%;
    }

    .repport-table td {
        padding: 0;
        min-width: 2em;
        height: 2.5em;
        position: relative;
    }

    .project-name{
        min-width: max-content !important;
        padding-left: 0.5% !important;
        text-align: left;
    }

    .project-name, .end-week{
        border-right: solid #bbb 1px;
    }

    .credit{
        display: block;
        background-color: #8d8;
        height: 1em;
        margin: 15% 0;
    }

    .icon-div{
        position: absolute;
        top: 20%;
        left: 10%;
    }

    .today{
        background-color: #ffe6bc;
    }

    .retard-div{
        width: max-content;
        background-color: white;
        padding: 0 15%;
        border: solid 1px #bbb;
        border-radius: 5px;
        color: #f44;
        box-shadow: 2px 2px 2px #bbb;
        z-index: 10;
    }

    .livraison-icon{
        border-radius: 50%;
        box-shadow: 2px 2px 2px #bbb;
    }

    .hidden{
        background-color: white;
        border: solid white 1px ;
        border-right-color: #e5a610 ;
    }

    th {
        border: solid 1px black;
    }

    .header-month{
        background-color: #fec053;
        border: solid #e5a610 1px;
    }

    .p-legend{
        display: inline-block;
        margin-right: 5%;
    }

    .credit-legend{
        margin: 0 1% 0 0 !important;
        width: 10%;
        display: inline-block !important;
    }

    .legend-icon{
        margin: 0;
    }

    .hours-icon{
        color: #f84;
    }

    .inline-div{
        display: inline;
        margin-left: 2%;
    }

    .legend-div {
        display: inline-block;
        width: 20%;
    }

    .invoice-icon{
        color: rgb(85, 187, 85);
    }

    .holiday {
        background-color: #ddd;
    }

    @media screen and (max-width: 1240px){

        .nb-stat-big{
            font-size: 4em;
        }

        .aside{
            width: 35%;
        }
    }

    @media screen and (max-width: 1024px){
        .legend-div {
            display: inline-block;
            width: 40%;
        }
    }

    @media screen and (max-width: 760px){

        .aside{
            width: 70%;
        }

        .dashboardLink{
            font-size: 1em;
        }

        .title-page{
            font-size: 2em;
        }

        .title-page{
            font-size: 1.1em;
        }

        #nextMonth, #previousMonth{
            font-size: 17px;
            margin-bottom: 0px;
        }
    }

    @media screen and (max-width: 525px){
        .legend-div {
            display: inline-block;
            width: 50%;
        }
    }

    @media screen and (max-width: 420px){
        .legend-div {
            display: inline-block;
            width: 75%;
        }
    }

</style>